import { container } from '@eureka/services/src/container';
import type { ICancelSubscriptionRequest, ICreatePaymentSessionRequest, ICreatePaymentSessionResponse, IGetInvoicesRequest, IResumeSubscriptionRequest, ISubscriptionListDTO } from '../types';

export interface IGetCheckSessionData {
  token: string;
  refresh_token: string;
}

export function createPaymentSession(params: ICreatePaymentSessionRequest): Promise<ICreatePaymentSessionResponse> {
    return container.RnDHttp.post<ICreatePaymentSessionResponse>({
        url: `${import.meta.env.VITE_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/checkout-session`,
        data: params,
    })
}

export function cancelSubscription(params: ICancelSubscriptionRequest): Promise<void> {
    return container.AccountHttp.post({
        url: `${import.meta.env.VITE_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/cancel-subscription`,
        data: params,
    }).then(res => {
        return res
    })
}

export function resumeSubscription(params: IResumeSubscriptionRequest): Promise<void> {
    return container.AccountHttp.post({
        url: `${import.meta.env.VITE_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/resume-subscription/${params.subscription_id}`,
        data: params,
    }).then(res => {
        return res
    })
}

export function getInvoices(params: IGetInvoicesRequest): Promise<string> {
    return container.AccountHttp.post({
        url: `${import.meta.env.VITE_ACCOUNT_SERVICE_URI}/user-service/payment/stripe/create-portal-session`,
        data: params,
    }).then(res => {
        return res
    })
}

export function getSubscriptionList(): Promise<ISubscriptionListDTO[]> {
    return container.AccountHttp.get({
        url: `${import.meta.env.VITE_ACCOUNT_SERVICE_URI}/user-service/payment/tenant-user/subscriptions`,
    }).then(res => {
        return res
    })
}

export function checkPaymentStatus(timestamp: string): Promise<boolean> {
    return container.AccountHttp.get({
        url: `${import.meta.env.VITE_ACCOUNT_SERVICE_URI}/user-service/payment/success?timestamp=${timestamp}`,
    }).then(res => {
        return res
    })
}
